/* ══════════════════════════════════════════════════════════════════════════
   CURATO — GLOBAL MOTION
   Prototype: index.html <script> — the scroll-reveal IntersectionObserver and
   the [data-px] parallax rAF loop, lifted verbatim.

   WHY THIS IS GLOBAL AND NOT PER-SECTION
   §1: "All motion in the prototypes is vanilla CSS/JS (IntersectionObserver +
   one rAF scroll handler). Keep it that way." One loop, one observer, for the
   whole document. .reveal and [data-px] are on the categories tiles, the UGC
   grid, the panels and the hero detail images — a copy per section would mean
   six scroll handlers fighting each other against a Lighthouse ≥90 budget.

   The prototype's other behaviours (veil, wipe, announcement rotation, header
   state, hero stills) are single-owner and already live in their own sections.
   Only these two are cross-section.

   ⚠️ THE ONE DELIBERATE DEVIATION
   The prototype reads the breakpoint once at load. Load on desktop, resize to
   mobile, and every parallaxed image keeps its inline scale(1.06) + offset
   forever — visibly broken, and §2 says parallax is "desktop only". So the
   breakpoint is re-synced on change and inline transforms are cleared on the
   way down. Nothing moves at 1600 / 1080 / 390, so pixel-match is unaffected.

   LOAD IT FROM theme.liquid, ONCE, ABOVE </head>:
     <script src="{{ 'curato-motion.js' | asset_url }}" defer="defer"></script>
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
  if (window.__curatoMotion) return;
  window.__curatoMotion = true;

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = matchMedia('(min-width: 761px)');

  /* ── scroll reveals ──────────────────────────────────────────────────────
     Verbatim: threshold .12, rootMargin '0px 0px -40px 0px', fire once.
     Stagger is CSS (.reveal:nth-child(n) transition-delay), not JS. */
  var io = null;

  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
  }

  function observeReveals(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.in)');
    for (var i = 0; i < els.length; i++) {
      if (io) io.observe(els[i]);
      else els[i].classList.add('in'); // reduced motion / no IO support
    }
  }

  /* ── parallax on [data-px] — desktop only ────────────────────────────────
     Verbatim: ±8px translateY scaled by the element's data-px, over a 1.06
     overscan so the offset never exposes an edge. rAF-throttled, passive. */
  var pxEls = [];
  var ticking = false;

  function parallax() {
    var vh = innerHeight;
    for (var i = 0; i < pxEls.length; i++) {
      var el = pxEls[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      var p = (r.top + r.height / 2 - vh / 2) / vh; // -0.5..0.5
      var amt = parseFloat(el.getAttribute('data-px'));
      el.style.transform = 'translateY(' + p * amt * -8 + 'px) scale(1.06)';
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    requestAnimationFrame(parallax);
    ticking = true;
  }

  function syncParallax() {
    removeEventListener('scroll', onScroll);
    for (var i = 0; i < pxEls.length; i++) pxEls[i].style.transform = '';
    pxEls = [];

    if (reduced || !desktop.matches) return;

    pxEls = [].slice.call(document.querySelectorAll('[data-px]'));
    if (!pxEls.length) return;

    addEventListener('scroll', onScroll, { passive: true });
    parallax();
  }

  function init() {
    observeReveals(document);
    syncParallax();
  }

  if (document.readyState === 'loading') {
    addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (desktop.addEventListener) desktop.addEventListener('change', syncParallax);

  /* ── theme editor lifecycle ──────────────────────────────────────────────
     Sections are injected and torn down without a page load. Re-scan both. */
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
    syncParallax();
  });

  document.addEventListener('shopify:section:unload', syncParallax);
})();